import { defineStore } from 'pinia';

export const useCarwashClinicStore = defineStore('carwashClinicStore', {
    state: () => ({
        products: [],
        questions: [
            {
                question: 'Kuinka likainen autosi on?',
                answers: [
                    { selected: false, answer: 'Melko puhdas (kevyttä pölyä, pisaravalumia)', points: 1 },
                    { selected: false, answer: 'Melko likainen (siitepölyä, tuoretta rapaa)', points: 2 },
                    { selected: false, answer: 'Likainen (tiesuolaa, hyönteisiä, lintujen jätöksiä)', points: 4 },
                    { selected: false, answer: 'Todella likainen (piki, pinttynyt rapa, jarrupölyä)', points: 8 },
                ],
            },
            {
                question: 'Kuinka kauan edellisestä autopesustasi on?',
                answers: [
                    { selected: false, answer: 'Alle viikko', points: 0 },
                    { selected: false, answer: 'Alle kuukausi', points: 2 },
                    { selected: false, answer: 'Alle 2 kk', points: 3 },
                    { selected: false, answer: 'Yli 2 kk', points: 8 },
                ],
            },
            {
                question: 'Säilytätkö autoasi ajoittain lämpimässä tilassa?',
                answers: [
                    { selected: false, answer: 'Ei', points: 0 },
                    { selected: false, answer: 'Kyllä', points: 3 },
                ],
            },
        ],
        points: [],
        step: 0,
        recommendedProductId: null,
    }),
    actions: {
        reset() {
            this.points = [];
            this.step = 0;
            this.recommendedProductId = null;
            this.questions.forEach(question => question.answers.map(answer => answer.selected = false));
        },
        nextStep() {
            this.step = this.step + 1;
            if (this.step >= this.questions.length) this.step = this.questions.length - 1;
        },
        prevStep() {
            if (this.step === 0) return;
            this.step = this.step - 1;
        },
        setStep(step) {
            this.step = step;
        },
        toggleSelect(question, answer, points) {
            this.questions[question].answers.forEach(answer => {
                answer.selected = false;
            });
            this.questions[question].answers[answer].selected = true;
            this.points[question] = points;
            this.setRecommended();
            this.nextStep();
        },
        getStepStatus(step) {
            return {
                answered: this.questions[step].answers.map(answer => answer.selected).includes(true),
                active: this.step === step,
            };
        },
        isCompleted() {
            return !this.questions.map((question, index) => this.getStepStatus(index).answered === true).includes(false);
        },
        setRecommended() {
            const points = this.points.reduce((partialSum, a) => partialSum + a, 0);

            this.products.forEach(product => {
                const [productData] = product.products.filter(p => !p.isBundle);

                // Go with the default product to prevent the survey from breaking.
                if (!productData) {
                    this.recommendedProductId = 'tornado-3';
                } else if (productData.attributes.CarwashSurveyPoints >= points) {
                    this.recommendedProductId = productData.code;
                }
            });
        },
        setProducts(products) {
            this.products = products;
        },
    },
    getters: {
        getSum: state => state.points.reduce((partialSum, a) => partialSum + a, 0),
    },
});
